import Vue from "vue";

Vue.mixin({
  methods: {
    getFileIcon(type) {
      let icon = {
        name: "",
        color: "",
      };
      switch (type) {
        case "text/csv":
          icon = {
            color: "#048748",
            name: "fa-file-excel",
          };
          break;
        case "application/vnd.ms-excel":
          icon = {
            color: "#048748",
            name: "fa-file-excel",
          };
          break;
        case "application/pdf":
          icon = {
            color: "#cc0000",
            name: "fa-file-pdf",
          };
          break;
        case "application/msword":
          icon = {
            color: "#00469B",
            name: "fa-file-word",
          };
          break;
        case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
          icon = {
            color: "#00469B",
            name: "fa-file-word",
          };
          break;
        case "text/plain":
          icon = {
            color: "#00a0dc",
            name: "fa-file-code",
          };
          break;
        default:
          icon = {
            color: "#909399",
            name: "fa-file-alt",
          };
          break;
      }

      return icon;
    },
    getExtension(filename) {
      var parts = filename.split('.');
      return parts[parts.length - 1];
    },
    isFileDocumnet(name) {
      var ext = this.getExtension(name);
      const fileTypes = [
        "jpg",
        "jpeg",
        "png",
        "doc",
        "docx",
        "xls",
        "xlsx",
        "pdf",
        "ppt",
        "pptx",
        "csv",
        "svg",
        "jfif"
      ];
      let filter = fileTypes.filter((filter) => ext == filter);
      if (filter.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    isFileImage(type) {
      const fileTypes = [
        "image/apng",
        "image/bmp",
        "image/gif",
        "image/jpeg",
        "image/pjpeg",
        "image/png",
        "image/svg+xml",
        "image/tiff",
        "image/webp",
        "image/x-icon",
      ];
      let filter = fileTypes.filter((filter) => type == filter);
      if (filter.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    isFileVideo(type) {
      const fileTypes = [
        "video/ogg",
        "video/mpeg",
        "video/webm",
        "video/mp4",
        "video/mpg",
        "video/wmv",
        "video/avi",
      ];
      let filter = fileTypes.filter((filter) => type == filter);
      if (filter.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    isFileAudio(type) {
      const fileTypes = [
        "audio/ogg",
        "audio/mid",
        "audio/x-aiff",
        "audio/wav",
        "audio/vnd.wav",
        "audio/mp3",
        "audio/mpeg",
        "audio/mp4",
        "audio/mpg",
        "audio/wmv",
        "audio/avi",
      ];
      let filter = fileTypes.filter((filter) => type == filter);
      if (filter.length > 0) {
        return true;
      } else {
        return false;
      }
    },
  },
});
